import { initializeApp } from "firebase/app";
import firebaseConfig from "../firebase/config.js";
import {
    getAuth,
    GoogleAuthProvider,
    signInWithPopup,
    sendSignInLinkToEmail,
    isSignInWithEmailLink,
    signInWithEmailLink
} from "firebase/auth";

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export { GoogleAuthProvider,
         signInWithPopup,
         sendSignInLinkToEmail,
         isSignInWithEmailLink,
         signInWithEmailLink};